import { useState, useEffect, useCallback, useRef } from 'react';

const Counter = ({ end, duration = 2000, suffix = '', isVisible }) => {
  const [count, setCount] = useState(0);
  const animationFrameIdRef = useRef(null);

  const animateCount = useCallback((timestamp, startTime) => {
    const progress = timestamp - startTime;
    const percentage = Math.min(progress / duration, 1);
    setCount(Math.floor(end * percentage));
    return percentage;
  }, [end, duration, setCount]);

  useEffect(() => {
    if (!isVisible) return;

    let startTime;
    
    const animate = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const percentage = animateCount(timestamp, startTime);
      if (percentage < 1) {
        animationFrameIdRef.current = requestAnimationFrame(animate);
      }
    };

    animationFrameIdRef.current = requestAnimationFrame(animate);
    
    return () => {
      if (animationFrameIdRef.current) {
        cancelAnimationFrame(animationFrameIdRef.current);
      }
    };
  }, [isVisible, animateCount]);

  return <span>{count}{suffix}</span>;
};

export default Counter;
